import React from 'react';
import { BlogCard } from '../ui/BlogCard';
import { Button } from '../ui/Button';
export function BlogSection() {
  const posts = [{
    image: 'https://images.unsplash.com/photo-1587745416684-47953f16f02f?w=800&q=80',
    date: 'March 15, 2024',
    title: '5 Benefits of Non-Emergency Medical Transportation',
    excerpt: 'Discover how NEMT services can improve healthcare access and patient outcomes.'
  }, {
    image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=80',
    date: 'March 10, 2024',
    title: 'How to Prepare for Your Medical Transport Appointment',
    excerpt: 'Essential tips to ensure a smooth and comfortable transportation experience.'
  }, {
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    date: 'March 5, 2024',
    title: 'Understanding Medicare Coverage for NEMT Services',
    excerpt: 'Learn about Medicare benefits and how they apply to medical transportation.'
  }];
  return <section className="bg-white py-20" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-13">
            Latest News & Resources
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-14">
            Stay informed with helpful articles and updates about medical
            transportation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-15">
          {posts.map((post, index) => <BlogCard key={index} {...post} link="#blog" data-id="element-16" />)}
        </div>

        <div className="text-center" data-id="element-17">
          <Button variant="secondary" size="lg" data-id="element-18">
            View All Blogs
          </Button>
        </div>
      </div>
    </section>;
}